import React from 'react';
import { t } from 'ttag';

export default function SearchCategories({ searchResults, searchQuery }) {
  const { navigation_items: navigationItems } = searchResults;

  if (!navigationItems?.length) return null;

  return (
    <section>
      <h2 className="mb-4 mt-8 text-base font-semibold uppercase text-dark-gray">{t`Suggested Categories`}</h2>
      <ul
        className="m-0 list-none space-y-2 p-0"
        data-testid="suggested-categories"
      >
        {navigationItems?.map(navigationItem => (
          <li key={navigationItem.name}>
            <a
              href={`${navigationItem.url}?search_query=${searchQuery}`}
              className="m-0 block border-0 border-b-2 border-solid border-transparent bg-transparent p-0 py-2 text-left text-2xl font-semibold text-black outline-none transition-colors duration-150 ease-in-out focus:outline-none"
            >
              {navigationItem.name}
            </a>
          </li>
        ))}
      </ul>
    </section>
  );
}
